import React, { useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { pdfjs } from 'react-pdf';
import "./pdf.css";


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function AllPagesPDFViewer(props: any) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  const { pdf } = props;
  const pdfScale = 1.5; // Adjust scale for better resolution

  return (
    <Document
      file={pdf}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={console.error}
      className="bg-body-tertiary"
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page key={`page_${index + 1}`} pageNumber={index + 1} />
      ))}
    </Document>
  );
}
